import React from 'react';
import { View, Text } from 'react-native';
import { loadStripe, type Stripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { create_setup_intent } from '../api/payment';
import { APP_STRIPE_PUBLIC_KEY } from '@env';
import { useLanguage } from './LanguageContext';

interface Props {
    children: React.ReactNode;
}

export const StripeContainer: React.FC<Props> = ({ children }) => {
    const { currentLanguage } = useLanguage();
    const [stripePromise, setStripePromise] =
        React.useState<Promise<Stripe | null> | null>(null);
    const [clientSecret, setClientSecret] = React.useState<string | null>(null);

    React.useEffect(() => {
        if (APP_STRIPE_PUBLIC_KEY && APP_STRIPE_PUBLIC_KEY !== '') {
            setStripePromise(loadStripe(APP_STRIPE_PUBLIC_KEY));
        } else {
            console.warn('Stripe public key is not set');
        }
    }, []);

    React.useEffect(() => {
        if (!stripePromise) return;
        const setupIntent = async (): void => {
            const data = await create_setup_intent();
            const item = data?.item;
            setClientSecret(item.client_secret);
        };
        setupIntent();
    }, [stripePromise]);

    if (APP_STRIPE_PUBLIC_KEY === '') {
        return <>{children}</>;
    }

    if (
        (APP_STRIPE_PUBLIC_KEY &&
            APP_STRIPE_PUBLIC_KEY !== '' &&
            !clientSecret) ||
        !stripePromise
    ) {
        return (
            <View>
                <Text>Loading...</Text>
            </View>
        );
    }

    const options = {
        clientSecret,
        locale: currentLanguage,
        paymentMethodOrder: ['card'],
    };

    return (
        <Elements stripe={stripePromise} options={options}>
            {children}
        </Elements>
    );
};
